import type { ComponentProps, PropsWithChildren } from 'react';
import type React from 'react';

import { cn } from '@change/ds-utils';

type Variant = 'error' | 'success' | 'purple';

type Props = Readonly<{
	big?: boolean;
	/**
	 * default: error (yellow)
	 */
	variant?: Variant;
}>;

// error/success use Sunrise semantic tokens (see @change/ds-tokens); purple has no matching
// semantic token and is preserved from the previous theme-ui styling.
const VARIANT_CLASSES: Record<Variant, string> = {
	error:
		'border-b border-solid border-stroke-warning bg-fill-warning-weaker text-typography-warning [&_a]:text-typography-warning',
	success:
		'border-b border-solid border-stroke-success-weak bg-fill-success-weaker text-typography-success [&_a]:text-typography-success',
	purple: 'border-b border-solid border-[#ffe9aa] bg-[#3E1B63] text-white',
};

export const BannerWrapper: React.FC<PropsWithChildren<Props> & Omit<ComponentProps<'div'>, 'variant'>> = ({
	children,
	big,
	variant = 'error',
	className,
	...rest
}) => {
	return (
		<div role="alert" data-nosnippet className={cn(VARIANT_CLASSES[variant], className)} {...rest}>
			{/* "small" container: full-width on mobile, 740px at md, 960px at lg (max 960px) */}
			<div
				className={cn(
					'mx-auto max-w-[960px] px-2 md:w-[740px] lg:w-[960px] [&_a]:font-bold [&_a]:underline',
					big ? 'py-2 text-base leading-6' : 'py-0.5 text-sm leading-5',
				)}
			>
				{children}
			</div>
		</div>
	);
};
